import React from "react";
import Modal from '../../component/Inc/Modal';
import Upload from "../../component/Inc/Upload";
function PopPRBookletStock(props) {
  const { open, close } = props;  
  return (
    <Modal open={open} close={close} type="pop_pr_booklet_stock">
      <h2 className='pop_tit'>홍보책자 목록 관리</h2>
      <div className="content_container scroll">
        <div className="com_input_wrap flex_row">
          <select className="select xs">
            <option value="영역 선택">영역 선택</option>
          </select>
          <select className="select xs">
            <option value="과목 선택">과목 선택</option>
          </select>
        </div>
        <div className="check">
          <input type="radio" name="rdo" id="rdo_01" className="com_chk circle"/>
          <label htmlFor="rdo_01">인쇄책자</label>
          <input type="radio" name="rdo" id="rdo_02" className="com_chk circle"/>
          <label htmlFor="rdo_02">디지털 책자</label>
        </div>
        <div className="list">
          <div className="check">
            {[1,2,3,4,5,6,7,8,9].map((i, idx) => {
              return (
                <div className="check_item" key={idx}>
                  <input
                    type="radio"
                    name="chk1"
                    id={`chk1_${idx}`}
                    className="com_chk"
                  />
                  <label htmlFor={`chk1_${idx}`}>
                    수학 탄탄 교재
                  </label>
                </div>
              );
            })}
          </div>
        </div>
        <section className="com_board_search">
          <article className="search">
            <input
              type="search"
              placeholder="교사명 검색"
              className="input xs type_search"
            />
            <button className="com_btn gray ws xs icon_search"></button>
          </article>
        </section>
        <div className="com_input_upload">
          <Upload title="파일 등록" className="com_btn gray xs wl" />
          <p className="file">
            <span className="txt">File name.pdf</span>
            <button
              type="button"
              className="btn_del_file"
              onClick={() => {}}
            ></button>
          </p>
        </div>
        <hr className="com_divider" />
        <div className="com_btn_wrap center">
          <button className="com_btn orange xs">등록</button>
        </div>
      </div>
    </Modal>
  );
}

export default PopPRBookletStock;